import { Landing } from './pages/rp-nutri-sapere';

const App = () => <Landing />

export default App;
